import './RejectionBanner.css';

/**
 * RejectionBanner - Read-only informational banner showing rejection details.
 * 
 * Renders only when rejectionReason is truthy.
 * 
 * Props:
 *   rejectionReason - The rejection reason text
 *   rejectedByName - Name of the admin who rejected
 *   rejectedAt - ISO timestamp string of when the rejection occurred
 */
function RejectionBanner({ rejectionReason, rejectedByName, rejectedAt }) {
  if (!rejectionReason) return null;

  const formatTimestamp = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  return (
    <div className="rejection-banner" role="alert">
      <div className="rejection-banner-header">
        <span className="rejection-banner-icon">⚠️</span>
        <strong className="rejection-banner-title">Shipment Rejected</strong>
      </div>
      <div className="rejection-banner-content">
        <p className="rejection-banner-reason">{rejectionReason}</p>
        <div className="rejection-banner-meta">
          {rejectedByName && (
            <span className="rejection-banner-admin">Rejected by: <strong>{rejectedByName}</strong></span>
          )}
          {rejectedAt && (
            <span className="rejection-banner-time">{formatTimestamp(rejectedAt)}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default RejectionBanner;
